// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".normal[data-v-f59dcf8a] {\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n  color: var(--white);\n  margin: auto;\n}\n.overallocated[data-v-f59dcf8a] {\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n  color: var(--white);\n  margin: auto;\n}\n.header-text[data-v-f59dcf8a] {\n  text-align: center;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
